window.initializeTableSelector = function () {
    let tableSelectable = $(document).find('.nc-table-selectable:not(.initialized)');

    if (tableSelectable.length) {
        tableSelectable.addClass('initialized');
        let tableSelectButton = $(document).find('.nc-table-select');

        tableSelectable.on('click', '.row-select', function (e) {
            toggleRow($(this));
            toggleButtons();
        });

        tableSelectable.on('click', '.all-row-select', function () {
            if ($(this).is(':checked')) {
                $('.row-select').prop('checked', true)
                    .closest('tr')
                    .addClass('selected');
            } else {
                $('.row-select').prop('checked', false)
                    .closest('tr')
                    .removeClass('selected');
            }

            toggleButtons();
        });

        function toggleRow(checkbox) {
            if ($(checkbox).is(':checked')) {
                $(checkbox).closest('tr').addClass('selected');
            } else {
                $(checkbox).closest('tr').removeClass('selected');
            }
        }

        function toggleButtons() {
            let quantity = tableSelectable.find('.row-select:checked').length;
            if (!tableSelectButton.data('all-enabled')) {
                if (quantity > 0) {
                    tableSelectButton.find('> button').removeClass('disabled');
                } else {
                    tableSelectButton.find('> button').addClass('disabled');
                }
                return;
            }

            // Add/remove disabled class from select button(s).
            if (quantity > 0) {
                tableSelectButton.find('.selector-text').text(
                    replaceItemCount(tableSelectButton.data('title-selection'), quantity)
                )
            } else {
                tableSelectButton.find('.selector-text').text(
                    tableSelectButton.data('title-all')
                );
            }
        }

        tableSelectButton.on('click', '.dropdown-menu a, .dropdown-menu button', function (e) {
            e.preventDefault();

            /** Get selected table rows */
            let ids = [];
            $('.row-select:checked').each(function () {
                ids.push($(this).val());
            });

            if ($(this).data('custom') === true) {
                this.dataset.ids = ids;
                $(this).data('ids', ids);
                return;
            }

            /** Support for side panels */
            if ($(this).data('route')?.length && $(this).data('toggle')?.length) {
                let url = $(this).data('route');
                let oldURL = url;
                if (ids.length) {
                    url += '?ids=' + ids.join(',')
                }
                $(this).data('route', url);

                /** set the old URL back */
                setTimeout(() => {
                    $(this).data('route', oldURL);
                }, 100);
                return;
            }

            let url = $(this).attr('href');
            if (ids.length) {
                url += '?ids=' + ids.join(',')
            }

            if ($(this).data('confirm-text')) {
                confirm($(this).data('confirm-text'), function () {
                    window.location.href = url;
                });
                return;
            }

            let text = '';

            if (ids.length) {
                text = replaceItemCount($(this).closest('.nc-table-select').data('confirm-selection'), ids.length)
            }

            if (!text.length) {
                text = $(this).closest('.nc-table-select').data('confirm-all')
            }

            confirm(text, function () {
                window.location.href = url;
            });
        });

        function replaceItemCount(text, count) {
            return text.replace(/\(\d+/, '(' + count);
        }
    }
};